import React from 'react';

import { CopyToClipboard } from '@/components/CopyToClipboard';
import { OverflowText } from '@/components/OverflowText';

export const NameColumn = ({
  name,
  description,
  icon,
}: {
  name: string;
  description?: string;
  icon?: React.ReactNode;
}) => {
  return (
    <div className="flex w-full flex-col gap-1 overflow-hidden py-3">
      <CopyToClipboard>
        <div className="flex gap-1">
          <OverflowText
            className="text-chariot-brand-primary group-[.is-selected]:text-chariot-text-primary shrink cursor-pointer truncate font-bold"
            text={name}
          />
          {icon}
        </div>
      </CopyToClipboard>
      {description && (
        <CopyToClipboard>
          <OverflowText
            className="overflow-hidden text-xs"
            text={description}
          />
        </CopyToClipboard>
      )}
    </div>
  );
};
